import { bootstrapAction } from '../extensions';
import { setSlideshow } from '../../utils/slideshow';

export class SlideshowPlugin {
  init() {
    bootstrapAction.register(this.bootstrap.bind(this));
  }

  async bootstrap() {
    setSlideshow();
  }
}
